import React from "react"
import { Box } from "@mui/material"

import { PrimitiveInput } from "@/primitives/PrimitiveInput"
import { CharacterCount } from "@/components/Input/CharacterCount"
import { InputFieldProps } from "@/components/Input/protocols"

import useStyles from "@/components/Input/Field/styles"

export const Field = ({
	errorText,
	multiline,
	characterCount,
	endAdornment,
	sx,
	...props
}: InputFieldProps) => {
	const classes = useStyles()

	const showError = Boolean(errorText)
	const showCounter = Boolean(characterCount)

	return (
		<Box position="relative" width="100%">
			<PrimitiveInput
				{...props}
				multiline={multiline}
				endAdornment={endAdornment}
				sx={{
					...classes.input,
					...(showError ? classes.inputError : {}),
					...(multiline && {
						alignItems: "flex-start",
						paddingTop: "0.75rem",
						paddingBottom: "0.75rem"
					}),
					...(showCounter && {
						paddingBottom: "2rem"
					}),
					...sx
				}}
			/>
			{showCounter && (
				<Box
					position="absolute"
					bottom={10}
					right={12}
					sx={{ pointerEvents: "none" }}
				>
					<CharacterCount value={props.value ?? ""} maxLength={characterCount!.maxLength} />
				</Box>
			)}
		</Box>
	)
}
